import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';

export type NumericTextFieldProps = Omit<TextFieldProps, 'value' | 'onChange'> & {
  value: string | number;
  onChange: (val: string) => void;
  allowDecimal?: boolean;
};

export const NumericTextField: React.FC<NumericTextFieldProps> = ({
  value,
  onChange,
  allowDecimal = false,
  ...rest
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    const regex = allowDecimal ? /^\d*\.?\d*$/ : /^\d*$/;
    if (regex.test(val)) {
      onChange(val);
    }
  };

  return (
    <TextField
      {...rest}
      value={value}
      onChange={handleChange}
      inputProps={{
        inputMode: allowDecimal ? 'decimal' : 'numeric',
        autoComplete: 'off',
        ...rest.inputProps,
      }}
    />
  );
};
